import React, {useEffect, useState} from 'react'
import {Rect, Text, Transformer} from "react-konva";
import _, {parseInt} from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

let INFO_TEXT: any = {
    x: 0,
    y: 40,
    fontSize: 100,
    fontFamily: 'Calibri',
    fontStyle: 'bold',
    fill: '#555',
    width: 600,
    height: 180,
    align: 'center',
    listening: false,
}

let INFO_RECTANGLE: any = {
    width: 700,
    height: 200,
    strokeWidth: 5,
    cornerRadius: 10,
    listening: false
}

const TextShape = ({
                       shapeProps,
                       isSelected,
                       onSelect,
                       onChange,
                       stagePos,
                       transformerRef,
                       handleGuidelineDragEnd,
                       handleGuidelineDragMove
                   }) => {
    const shapeRef = React.useRef();
    const infoRectangleRef = React.useRef();
    const infoTextRef = React.useRef();
    /*const trRef = React.useRef();*/
    const [infoDetail, setInfoDetail] = useState(INFO_RECTANGLE);
    const [infoText, setInfoText] = useState(INFO_TEXT);

    /*useEffect(() => {
        /!*if ((isSelected) && transformerRef.current) {
            // we need to attach transformer manually
            // @ts-ignore
            transformerRef.current.nodes([shapeRef.current]);
            // @ts-ignore
            transformerRef.current.getLayer().batchDraw();
        }*!/
        /!*if ((isSelected) && trRef.current) {
            // we need to attach transformer manually
            // @ts-ignore
            trRef.current.nodes([shapeRef.current]);
            // @ts-ignore
            trRef.current.getLayer().batchDraw();
        }*!/
    }, [isSelected]);*/

    const handleClickV2 = (e) => {
        // handleTextClick(e)
        // processInfoText();
        /*onSelect(e);

        const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;
        const isSelected = transformerRef.current.nodes().indexOf(e.target) >= 0;

        if (!metaPressed && !isSelected) {
            // if no key pressed and the node is not selected
            // select just one
            transformerRef.current.nodes([e.target]);
        } else if (metaPressed && isSelected) {
            // if we pressed keys and node was selected
            // we need to remove it from selection:
            const nodes = transformerRef.current.nodes().slice(); // use slice to have new copy of array
            // remove node from array
            nodes.splice(nodes.indexOf(e.target), 1);
            transformerRef.current.nodes(nodes);
        } else if (metaPressed && !isSelected) {
            // add the node into selection
            const nodes = transformerRef.current.nodes().concat([e.target]);
            transformerRef.current.nodes(nodes);
        }*/
    }

    const processInfoRectangle = (event) => {
        const node = shapeRef.current || undefined;
        let existingInfoDetail = {...infoDetail} || {};

        /*existingInfoDetail.x = node.x() - node.offsetX() - 50;
        existingInfoDetail.y = node.y() - node.offsetY();*/
        /*existingInfoDetail.x = node.x() - 25 - node.width() / 2;
        existingInfoDetail.y = node.y() + 70 + node.height() / 2;*/
        // existingInfoDetail.stroke = node.fill();

        existingInfoDetail.x = stagePos.x;
        existingInfoDetail.y = stagePos.y + 150;
        existingInfoDetail.text = node.text();
        // existingInfoDetail.rotation = parseInt(node.rotation());
        existingInfoDetail.displayText = parseInt(node.x()) + ', ' + parseInt(node.y());

        setInfoDetail(existingInfoDetail);
        // processInfoText(existingInfoDetail);
    }

    const processInfoText = () => {
        const node = shapeRef.current || undefined;
        let existingInfoText: any = {...infoText} || {};

        /*existingInfoText.x = existingInfoDetail.x;
        existingInfoText.y = existingInfoDetail.y;*/
        existingInfoText.text = parseInt(node.x()) + ', ' + parseInt(node.y());
        // existingInfoText.rotation = existingInfoDetail.rotation;

        // setInfoText(existingInfoText);

        /*const infoTextNode = infoTextRef.current || undefined;

        if (infoTextNode) {
            infoTextNode.absolutePosition({x: 0, y: 20});
        }*/
    }

    const handleDragStart = (event) => {
        const isSelected = _.findIndex(transformerRef.current.nodes(), ['key', shapeProps?.key]) >= 0;
        if (!isSelected) {
            const nodes = transformerRef.current.nodes().concat([event.target]);
            transformerRef.current.nodes(nodes);
        }

        transformerRef.current.getLayer().batchDraw();
    }

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentTextRef = event.target;
        currentTextRef.position({
            x: Math.round(currentTextRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentTextRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: node.width(),
            totalHeight: node.height()
        });
    }

    const handleTransformEnd = (event) => {
        const node = shapeRef.current || undefined;

        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        node.scaleX(1);
        node.scaleY(1);

        const width = parseInt(String(Math.max(5, (node.width() * scaleX) + 10)));
        const height = parseInt(String(Math.max(5, (node.height() * scaleY) + 10)));

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            /*offsetX: node.offsetX(),
            offsetY: node.offsetY(),*/
            fontSize: parseInt(String(Math.max(node.fontSize() * scaleX))),
            totalWidth: width,
            totalHeight: height,
            width: width,
            height: height,
            rotation: node.rotation(),
        });
    }

    return (
        <>
            {/*{isSelected &&
                <>
                    <Rect
                        ref={infoRectangleRef}
                        {...infoDetail}
                    />

                    <Text
                        ref={infoTextRef}
                        {...infoText}
                    />
                </>
            }*/}

            <Text
                ref={shapeRef}
                {...shapeProps}
                name={'object'}
                draggable
                onTransformEnd={handleTransformEnd}
                onDragMove={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragMove(e);
                }}
                onDragEnd={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragEnd(e);
                }}
            />

            {/*{(isSelected) && (
                <Transformer
                    ref={trRef}
                    padding={5}
                    // centeredScaling={true}
                    // anchorFill={'#0ea5e9'}
                    // anchorStroke={'#0ea5e9'}
                    // enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}*/}

        </>
    )
}

export default TextShape
